module.exports = __webpack_public_path__ + "static/img/03.0b5fb4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/03.jpg
// module id = KUva
// module chunks = 1